<template>
  <b-modal
    id="mSaveCalcPersonalAccountTransactions"
    v-model="localActive"
    centered
    hide-footer
    hide-header
    @show="onShowModal"
    @close="localActive = false"
  >
    <div class="m-personal-account">
      <svg
        class="m-personal-account-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-personal-account-title">Операции с личным счетом</div>

      <div class="position-relative">
        <div id="m-personal-account-form-shadow-top" class="m-personal-account-form-shadow-top"></div>
        <div
          id="m-personal-account-form"
          class="m-personal-account-form"
          :class="{ 'm-personal-account-form-scrolled': personalAccountTransactionsItems.length > 100 }"
          @scroll="setShadowsOnScroll"
        >
          <div
            v-for="(item, index) in personalAccountTransactionsItems"
            :key="`personal-transaction-${index}`"
            class="m-personal-account-form-item"
            :class="{ 'm-personal-account-form-item-required': item.amountLocalError.length > 0 }"
          >
            <c-switcher
              v-model="item.switcherLocal"
              class="m-personal-account-form-item-switcher"
              :class="{
                'm-personal-account-form-item-switcher-red': item.switcherLocal === 'writeOff',
                'm-personal-account-form-item-switcher-green': item.switcherLocal === 'charge',
              }"
              type="group"
              :items="[
                { label: 'Списать', value: 'writeOff' },
                { label: 'Начислить', value: 'charge' },
              ]"
            />
            <div
              class="m-personal-account-form-item-summ"
              :class="{ 'm-personal-account-form-item-summ-required': item.amountLocalError.length > 0 }"
            >
              <c-input
                v-model="item.amountLocal"
                class="m-personal-account-form-item-summ-input"
                :input-text-condition="item.amountLocalError"
                placeholder="0"
                type="number"
              />
              ฿
            </div>
<!--            <c-input
              :ref="'textareaTransactions' + index"
              v-model="item.commentLocal"
              class="m-personal-account-form-item-comment"
              type="textarea"
              :clearable="true"
              placeholder="Комментарий"
            />-->
          <c-select
            v-model="item.reasonLocal2"
            class="m-personal-account-form-item-row-basis"
            type="select"
            label=""
            :clearable="true"
            :required="false"
            :searchable="true"
            :items="personalListForRecord(item, index)"
            placeholder="Выберите причину"
          />            
            <c-button
              v-if="personalAccountTransactionsItems.length > 1"
              :key="`remove-${index}-desktop`"
              class="m-personal-account-form-item-trash-desktop"
              title="Удалить"
              size="iconic"
              icon="trash"
              @click="removePersonalAccountTransactionItem(index)"
            />
            <c-button-2
              v-if="personalAccountTransactionsItems.length > 1"
              :key="`remove-${index}-mobile`"
              class="m-personal-account-form-item-trash-mobile"
              label="Удалить"
              title="Удалить"
              size="small"
              :icon="{
                icon: 'trash',
                color: 'secondary',
              }"
              @click="removePersonalAccountTransactionItem"
            />
          </div>
        </div>
        <div id="m-personal-account-form-shadow-bottom" class="m-personal-account-form-shadow-bottom" style="display:none"></div>
      </div>

      <div class="m-personal-account-result">
        <c-button-2
          size="small"
          label="Добавить"
          :icon="{
            icon: 'plus',
            color: 'blue',
          }"
          @click="addPersonalAccountTransactionItem"
        />
        <div class="m-personal-account-result-total">
          <div class="m-personal-account-result-total-title">
            Итого:
            <span
              class="m-personal-account-result-total-sum"
              :class="{
                'm-personal-account-result-total-sum-green': totalSum > 0,
                'm-personal-account-result-total-sum-red': totalSum < 0,
              }"
            >
              {{ totalSum }}
              ฿
            </span>
          </div>
        </div>
      </div>

      <div class="m-personal-account-actions">
        <c-button size="large" class="m-personal-account-actions-cancel" label="Отменить" @click="cancel" />
        <c-button
          class="m-personal-account-actions-save"
          label="Сохранить"
          color="primary"
          size="large"
          @click="submitForm"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from "@/components/controls2/Input";
import Button from "@/components/controls2/Button";
import button from "@/components/controls/button";
import Switcher from "@/components/controls2/Switcher";
import Select from "@/components/controls2/Select";

export default {
  name: "m-personal-account-transactions",

  components: {
    "c-input": Input,
    "c-button": Button,
    "c-button-2": button,
    "c-switcher": Switcher,
    "c-select": Select,

  },

  props: ["active", "data", "record", "calculationType", 'personalReasons'],

  data() {
    return {
      localActive: false,
      personalAccountTransactionsItems: [],
      submitAttempt: false,
      totalSum: 0,
      totalSumOnOpenModal: 0, 
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
        setTimeout(() => {
          this.personalAccountTransactionsItems = [];
          this.totalSum = 0;
        }, 200);
      }
    },
    active(value) {
      this.localActive = value;
    },
    data(value) {

      this.postLocalItems = value.posts.map((post) => ({
        label: post.name,
        value: post.code,
      }));
    },
    personalAccountTransactionsItems: {
      handler(newValue) {
        newValue.forEach((item) => {
          if (this.submitAttempt) {
            if (item.amountLocal.length === 0) {
              item.amountLocalError = "Обязательное поле";
            } else if (item.amountLocal<0) {
              item.amountLocalError = "Значение не может быть отрицательным";
            } else {
              item.amountLocalError = "";
            }
          }
        });
        this.setTotalSum();
      },
      deep: true,
    },
  },

  methods: {
    personalListForRecord(item, index)
    {
        const type = item.switcherLocal == "writeOff" ? 0 : 1;
        const res = this.personalReasons
        .filter((item) => item.type === type || item.type === 2 || item.type === null)
        .map((i) => ({ label: i.title, value: i.id }));
        if (index !== undefined)
        this.personalAccountTransactionsItems[index].reasonLocal = null;
        return res;
    }, 

    onShowModal() {
      if (
        this.record.personal_account_transactions.items &&
        this.record.personal_account_transactions.items.length > 0
      ) {
        this.record.personal_account_transactions.items.forEach(() => {
          this.personalAccountTransactionsItems.push({
            type: "-",
            switcherLocal: "writeOff",
            amountLocal: "",
            amountLocalError: "",
            reasonLocal: null,
            commentLocal: "",

          });
        });
        setTimeout(() => {
          this.personalAccountTransactionsItems = this.record.personal_account_transactions.items.map((item, index) => {
            var i = {
              type: item.type,
              switcherLocal: item.type === "+" ? "charge" : "writeOff",
              amountLocal: item.amount ? item.amount : "",
              amountLocalError: "",
              commentLocal: item.comment !== null ? item.comment : "",
            };


            i.reasonLocal2 = this.personalListForRecord(i).find((i)=>i.value==item.reason_id);
            //console.log(888, this.personalListForRecord(i), i.reasonLocal2)
            if (!i.reasonLocal2) i.reasonLocal2 =  this.personalListForRecord(i).find((i)=>i.value==47);

            return i;
          });
        }, 200);
      } else {
        this.personalAccountTransactionsItems.push({
          type: "-",
          switcherLocal: "writeOff",
          amountLocal: "",
          amountLocalError: "",
          commentLocal: "",
          reasonLocal: null,          
        });
      }

      this.setTotalSum();
      setTimeout(() => {
        this.totalSumOnOpenModal = this.totalSum;
      }, 200);
    },
    setTotalSum() {
      let sum = 0;
      this.personalAccountTransactionsItems.forEach((item) => {
        if (item.switcherLocal === "writeOff") {
          sum -= Number(item.amountLocal);
        } else {
          sum += Number(item.amountLocal);
        }
      });
      this.totalSum = Math.round(sum*100)/100;
    },
    handleScroll(e) {
      this.scrolled = e.target.scrollTop > 0;
    },
    cancel() {
      this.localActive = false;
    },
    addPersonalAccountTransactionItem() {
      this.personalAccountTransactionsItems.push({
        type: "+",
        switcherLocal: "charge",
        amountLocal: "",
        amountLocalError: "",
        commentLocal: "",
        reasonLocal: null,
      });
    },
    removePersonalAccountTransactionItem(index) {
      this.personalAccountTransactionsItems.splice(index, 1);
      this.setShadowsOnScroll();
    },
    setShadowsOnScroll() {
      const shadowBottomElement = document.getElementById("m-personal-account-form-shadow-bottom");
      const shadowTopElement = document.getElementById("m-personal-account-form-shadow-top");
      const scrollElement = document.getElementById("m-personal-account-form");
      if (scrollElement !== null) {
        // if container scrollable
        if (scrollElement.scrollHeight > scrollElement.clientHeight) {
          // top shadow handler
          if (scrollElement.scrollTop !== 0) {
            shadowTopElement.classList.add("m-personal-account-form-shadow-top-active");
          } else if (scrollElement.scrollTop === 0) {
            shadowTopElement.classList.remove("m-personal-account-form-shadow-top-active");
          }
          // bottom shadow handler
          if (scrollElement.scrollTop + scrollElement.clientHeight !== scrollElement.scrollHeight) {
            shadowBottomElement.classList.add("m-personal-account-form-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("m-personal-account-form-shadow-bottom-active");
          }
        } else {
          shadowTopElement.classList.remove("m-personal-account-form-shadow-top-active");
          shadowBottomElement.classList.remove("m-personal-account-form-shadow-bottom-active");
        }
      }
    },
    submitForm() {
      let isFormValid = true;

      this.personalAccountTransactionsItems.forEach((item) => {
        //console.log(item.amountLocal.);
        if (item.amountLocal === "" || item.amountLocal.length === 0) {
          item.amountLocalError = "Обязательное поле";
          isFormValid = false;
          this.submitAttempt = true;
       } else if (item.amountLocal<0) {
        item.amountLocalError = "Значение не может быть отрицательным";
          isFormValid = false;
          this.submitAttempt = true;
      }
      });

      if (this.personalAccountTransactionsItems.some((item) => item.amountLocalError.length === 0)) {
        isFormValid = true;
      }

      if (isFormValid) {
        this.$emit("submitPersonalAccountTransactionValue", {
          items: this.personalAccountTransactionsItems,
          sum: this.totalSum,
          totalOnLoad: this.totalSumOnOpenModal,
        });
        this.cancel();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-personal-account {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
  }

  &-form {
    display: flex;
    flex-direction: column;
    margin-top: 29px;
    padding-right: 10px;
    width: calc(100% + 10px);
   /* max-height: 243px; */

    @media screen and (max-width: 768px) {
      max-height: calc(100vh - 200px);
    }

    &-scrolled {
      overflow-y: auto;
      overflow-x: hidden;
    }

    &::-webkit-scrollbar {
      width: 4px !important;
      height: 4px !important;
      background: white;
      cursor: pointer;
      z-index: 300;
      position: relative;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 10px;
      background-clip: padding-box;
      border: none !important;
    }

    &::-webkit-scrollbar-track {
      background: #dfe4ef;
      width: 4px !important;
      border-radius: 10px;
      z-index: 300;
      position: relative;
    }

    &-shadow-top {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      background: transparent;
      opacity: 0;
      pointer-events: none;
      height: 30px;
      width: 100%;

      &-active {
        background: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(16.13%, rgba(255, 255, 255, 0)),
          color-stop(100%, #ffffff)
        );
        opacity: 1;
      }
    }

    &-shadow-bottom {
      position: absolute;
      background: transparent;
      bottom: 0;
      left: 0;
      pointer-events: none;
      height: 30px;
      width: 100%;
      opacity: 0;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
      }
    }

    &-item {
      display: flex;
      align-items: center;
      margin-bottom: 36px;

      &-required {
        padding-bottom: 28px;

        @media screen and (max-width: 768px) {
          padding-bottom: 0;
        }
      }

      @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        border-bottom: solid 1px #bfc9e0;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &-switcher {
        margin-right: 33px;

        @media screen and (max-width: 768px) {
          margin-right: 0;
          width: 100%;

          & ::v-deep .c-switcher-group {
            width: 100%;
          }

          & ::v-deep .c-switcher-group-item {
            width: 50%;
          }
        }

        &-red {
          ::v-deep & .c-switcher-group-item_active {
            background: #ffd3e8;
          }
        }

        &-green {
          ::v-deep & .c-switcher-group-item_active {
            background: #d0f4e3;
          }
        }
      }

      &-summ {
        max-width: 122px;
        width: 100%;
        font-size: 13px !important;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-right: 28px;

        @media screen and (max-width: 768px) {
          justify-content: flex-start;
          max-width: 100%;
          margin-top: 24px;
        }

        &-required {
          @media screen and (max-width: 768px) {
            margin-bottom: 22px;
          }
        }

        &-input {
          max-width: 100px;

          @media screen and (max-width: 768px) {
            max-width: 50%;
            width: 100%;
          }

          &::v-deep .c-input-required-text {
            white-space: normal !important;
          }

          &::v-deep .c-input-required_active {
            bottom: -28px;

            @media screen and (max-width: 768px) {
              bottom: -22px !important;
            }
          }
        }

        &-icon {
          margin-top: -9px;
          margin-left: 12px;
          line-height: 120% !important;
        }
      }

      &-comment {
        max-width: 307px;
        width: 100%;
        margin-right: 34px;

        @media screen and (max-width: 768px) {
          max-width: 100%;
          margin-right: 0;
          margin-top: 24px;
        }

        & ::v-deep .c-input {
          width: 307px !important;

          @media screen and (max-width: 768px) {
            width: 100% !important;
          }
        }
      }

      &-row-basis {
        max-width: 307px;
        width: 100%;
        margin-right: 34px;

        @media screen and (max-width: 768px) {
          max-width: 100%;
          margin-right: 0;
          margin-top: 24px;
        }

        & ::v-deep .c-input {
          width: 307px !important;

          @media screen and (max-width: 768px) {
            width: 100% !important;
          }
        }
      }

      &-trash-desktop {
        @media screen and (max-width: 768px) {
          display: none;
        }
      }

      &-trash-mobile {
        display: none;
        margin-left: auto;
        margin-top: 22px;
        padding-bottom: 20px;
        width: 104px;

        @media screen and (max-width: 768px) {
          display: block;
        }
      }
    }
  }

  &-result {
    max-width: 657px;
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-total {
      display: flex;

      &-title {
        font-size: 18px;
        line-height: 120%;
        color: #8e9cbb;
      }

      &-sum {
        &-red {
          color: #ff238d;
        }

        &-green {
          color: #12c971;
        }
      }
    }
  }

  &-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 40px;

    @media screen and (max-width: 768px) {
      width: 100%;
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-cancel {
      @media screen and (max-width: 768px) {
        width: 50%;
        border-radius: 0 !important;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 768px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0 !important;
        }
      }
    }

    &-save {
      margin-left: 10px;

      @media screen and (max-width: 768px) {
        border-radius: 0 !important;
        margin-left: 0;
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        height: 38px !important;

        @media screen and (max-width: 768px) {
          display: flex;
          justify-content: center;
          width: 100%;
          border-radius: 0 !important;
        }
      }
    }
  }
}
</style>
